import type { QueryLogEntry } from './types';

const MAX_LOG_SIZE = 500;

/**
 * Anchor the log & listeners on `window` so Vite HMR doesn't create
 * duplicate module-scoped arrays that lose entries between reloads.
 */
const WIN = typeof window !== 'undefined' ? (window as any) : ({} as any);
if (!WIN.__pmsQueryLog) WIN.__pmsQueryLog = [] as QueryLogEntry[];
if (!WIN.__pmsQueryLogListeners) WIN.__pmsQueryLogListeners = [] as Array<() => void>;

const getLog = (): QueryLogEntry[] => WIN.__pmsQueryLog;
const setLog = (next: QueryLogEntry[]) => { WIN.__pmsQueryLog = next; };
const getListeners = (): Array<() => void> => WIN.__pmsQueryLogListeners;

const notify = () => getListeners().forEach((fn) => fn());

/** Append an entry to the in-memory query log */
export const addLogEntry = (entry: QueryLogEntry): void => {
  const next = [entry, ...getLog()].slice(0, MAX_LOG_SIZE);
  setLog(next);
  console.log(`[PMS QueryLog] entry added: ${entry.method} ${entry.resource} ${entry.source} [${entry.status}]${entry.error ? ' — ' + entry.error : ''} | total:`, next.length);
  notify();
};

/** Return a snapshot of the current log (newest-first) */
export const getQueryLog = (): ReadonlyArray<QueryLogEntry> => getLog();

/** Clear the log */
export const clearQueryLog = (): void => {
  setLog([]);
  notify();
};

/** Subscribe to log changes – returns an unsubscribe function */
export const subscribeQueryLog = (fn: () => void): (() => void) => {
  getListeners().push(fn);
  return () => {
    WIN.__pmsQueryLogListeners = getListeners().filter((l: () => void) => l !== fn);
  };
};

/** Helper: generate a unique id */
export const uid = (): string =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
